var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "scheduler-container" }, [
    _c(
      "div",
      { staticClass: "schedule-header" },
      _vm._l(_vm.columns, function(c) {
        return _c("div", [_vm._v(_vm._s(c.name))])
      })
    ),
    _vm._v(" "),
    _c("div", { staticClass: "scheduler-scroll-container" }, [
      _c(
        "div",
        { staticClass: "schedule-container" },
        [
          _c(
            "div",
            { staticClass: "schedule-timeline" },
            _vm._l(_vm.displayTicks, function(t) {
              return _c("div", { key: t[1] }, [_vm._v(_vm._s(t[1]))])
            })
          ),
          _vm._v(" "),
          _vm._l(_vm.columns, function(c, i) {
            return _c(
              "div",
              { staticClass: "schedule-column", attrs: { "data-columnid": i } },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.shadowPeriodColumn === c,
                        expression: "shadowPeriodColumn === c"
                      }
                    ],
                    staticClass: "shadow-period",
                    class: { "shadow-period-hidden": !_vm.startedAdd },
                    style: {
                      top: _vm.shadowPeriodStart + "px",
                      height: _vm.shadowPeriodEnd + "px"
                    }
                  },
                  [
                    _c("div", { staticClass: "shadow-period-coords" }, [
                      _vm._v(
                        "\n          start:" +
                          _vm._s(_vm.shadowPeriodStartTimeFormatted) +
                          "\n          end:" +
                          _vm._s(_vm.shadowPeriodEndTimeFormatted) +
                          "\n        "
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm._l(c.periods, function(period) {
                  return _c(
                    "div",
                    {
                      key: period.id,
                      staticClass: "period",
                      class: {
                        "period-shadow": c.offsets[period.id][2],
                        "period-editing": _vm.editDlg.pinnedTo === period
                      },
                      style: {
                        top: _vm.periodToPixels(period).start + "px",
                        height: _vm.periodToPixels(period).height + "px",
                        width: c.offsets[period.id][0] + "%",
                        "margin-left": c.offsets[period.id][1] + "px"
                      },
                      on: {
                        click: function($event) {
                          if ($event.target !== $event.currentTarget) {
                            return null
                          }
                          _vm.editPeriod(period)
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "period-header" }, [
                        _c("div", [
                          _vm._v(_vm._s(_vm.formatPeriodTitle(period)))
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "period-time" }, [
                          _vm._v(
                            _vm._s(_vm.formatTime(period.start)) +
                              " - " +
                              _vm._s(_vm.formatTime(period.end))
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "period-time" }, [
                          _vm._v(_vm._s(period.location))
                        ])
                      ])
                    ]
                  )
                })
              ],
              2
            )
          })
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-815962b4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-815962b4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/event/scheduler.vue
// module id = VUAA
// module chunks = 1